import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/profilepic.jpg";
// import myImg from "../../Assets/Avatar.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiOutlineMail } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import "./Home2.css"; // Add this CSS file for custom styling

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Hi Everyone! I am <b className="purple">Athmika U</b>.
              <br />
              <br />
              I'm a developer, passionate about{" "}
              <i>
                <b className="purple">
                  building meaningful projects, solving problems, and learning
                  new technologies.
                </b>
              </i>
              <br />
              <br />
              My core skills include{" "}
              <i>
                <b className="purple">Java, SQL, and JavaScript (Basics)</b>
              </i>{" "}
              and I enjoy working with{" "}
              <b className="purple">modern frameworks</b> to create{" "}
              <b className="purple">efficient and scalable applications</b>.
              <br />
              <br />
              I have recently started exploring{" "}
              <b className="purple">Cloud Computing</b> and look forward to
              broadening my skill set in this area as well.
              <br />
              <br />
              I'm always eager to{" "}
              <b className="purple">learn new things</b> and{" "}
              <b className="purple">apply my knowledge</b> to real-world
              challenges.
              <br />
              <br />
              Beyond coding, I enjoy{" "}
              <b className="purple">
                Sketching, Painting, Listening to Music, Solving Rubik's Cubes,
                and Traveling!
              </b>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={myImg}
                className="img-fluid rounded-img"
                alt="avatar"
              />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect</span> with me - I'd
              love to collaborate and share ideas!
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/AthmikaU"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/athmikau/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:athmikaubhat@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
